import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Snackbar from '@material-ui/core/Snackbar';
import MySnackbarContentWrapper from '../../layouts/SnackBars';
import { BudgetYears, SlipDataLoad } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    padding: theme.spacing(1),
    overflowX: 'hidden'
  },
  button: {
    marginBottom: theme.spacing(1),
    textAlign: 'left'
  },
  content: {
    marginTop: theme.spacing(1)
  },
  paper: {
    padding: theme.spacing(1),
    marginBottom: theme.spacing(1),
    textAlign: 'left',
    color: theme.palette.text.secondary,
    minHeight: '80px'
  }, heading: {
    fontSize: theme.typography.pxToRem(15),
  },
}));

const LoadDatas = () => {
  const classes = useStyles();
  const [budgetYears, setBudgetYears] = useState(''); // return value from child 
  const [loadValue, setLoadValue] = useState([]); // return value from child
  const [profile] = useState(JSON.parse(localStorage.getItem('profile')));

  const [openSnack, setOpenSnack] = useState(false);
  const [snackMessage] = useState();
  const [snackVariant] = useState('success');

  
  const getBudgetYearValue = BudgetyearsValue => {
    setBudgetYears(BudgetyearsValue);
  }

  const getLoadValue = LoadValue => {
    setLoadValue(LoadValue);
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnack(false);
  };

  return (
    <div className={classes.root} >
      <Grid container spacing={3}>
        <Grid item xs={12} sm={3}>
          <Paper className={classes.paper}>
            <BudgetYears getBudgetYearValue={getBudgetYearValue} />
          </Paper>
        </Grid>
      </Grid>
      <Paper className={classes.paper}>
        {/*<SlipDataLoad budgetYears={budgetYears} getLoadValue={getLoadValue} />*/}
      </Paper>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        open={openSnack}
        autoHideDuration={2000}
        onClose={handleClose}
      >
        <MySnackbarContentWrapper
          onClose={handleClose}
          variant={snackVariant}
          message={snackMessage}
        />
      </Snackbar>
    </div>
  );
};

export default LoadDatas;
